import React, {useState, useMemo, useEffect} from 'react';
import { motion } from "framer-motion"
import axios from 'axios';
import '../App.css';

function Vessels() {
    const [vesselFeed, setVesselFeed] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState();
  const [searchInput, setSearchInput] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);

  const [imageLoading, setImageLoading] = useState(true);
  const [pulsing, setPulsing] = useState(true);

  const imageLoaded = () => {
    setImageLoading(false);
    setTimeout(() => setPulsing(false), 600);
  };

  

  useEffect(() => {
    const config = {
      method: 'GET',
      url: 'https://fellesvedlikehold.azurewebsites.net/api/GetShipInfo?code=GhKeIOmPodIiA9Kyg3dkJHw_AqHQmXkAdqLe79nb4n6PAzFuKb8vuQ==',
      // url: './fartoy.js',
      headers: {
                  'Content-Type': 'application/json;charset=UTF-8',
                  "Access-Control-Allow-Origin": "*",
                  'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
                  'Access-Control-Allow-Headers': '*'
               }
  }
    axios(config).then(res => {
      const vesselList = res.data;
      setVesselFeed(vesselList);
      console.log(vesselList);
      setFilteredResults(vesselList);

    })
  }, []);


  const searchVessels = (searchValue) => {
    setSearchInput(searchValue)
    const filteredData = vesselFeed.filter((vessel) => {
      return Object.values(vessel.Navn).join('').toLowerCase().includes(searchInput.toLowerCase())
    })
    setFilteredResults(filteredData)
    console.log(filteredData);
  }

  const vesselCategories = Object.values(vesselFeed.reduce((a,{Type})=>{
    a[Type]={Type}
    return a;
 },{}))

 const vesselCategoriesFiltered = vesselCategories.filter(x => x.Type !== "");
 
 console.log(vesselCategoriesFiltered)

  function getFilteredVesselList() {
    if (!selectedCategory) {
      return filteredResults;
    }
    return filteredResults.filter((vessel) => vessel.Type === selectedCategory);
  }

  // Avoid duplicate function calls with useMemo
  var filteredVesselList = useMemo(getFilteredVesselList, [selectedCategory, filteredResults]);

  function handleCategoryChange(event) {
    setSelectedCategory(event.target.value);
  }
  
  let vessels; 
  let vesselCategoryOptions;

  vesselCategoryOptions = vesselCategoriesFiltered
    .map((category, index) => (
      <option value={category.Type} key={index}>{category.Type}</option>
    ));


    
  vessels = filteredVesselList
    .sort(function(a, b) {
      if(a.Navn.toLowerCase() < b.Navn.toLowerCase()) return -1;
      if(a.Navn.toLowerCase() > b.Navn.toLowerCase()) return 1;
      return 0;
    })
    .map((vessel, index) => (
    <motion.div 
      layout
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="col-md-4 white-card-container" key={vessel.id}>
      <div className="white-card d-flex flex-column justify-content-between">
        <div>
        <div>
          <motion.img
            initial={{ height: "16rem", opacity: 0 }}
            // style={{ height: imageLoading ? "6rem" : "auto" }}
            animate={{
              height: imageLoading ? "16rem" : "auto",
              opacity: imageLoading ? 0 : 1
            }}
            transition={
              ({ height: { delay: 0, duration: 0.4 } },
              { opacity: { delay: 0.5, duration: 0.4 } })
            }
            onLoad={imageLoaded}
            onError={(e) =>
                      (e.target.onerror = null)(
                        (e.target.src =
                          "https://uploads-ssl.webflow.com/6308a0081a24641f86439830/630e1048cc9f7a7659032fed_ocean2.jpg")
                      )
                    }
            className="img-fluid vesselImage" src={vessel.LinkBilde}
            alt=""
            loading="lazy"
            />
        </div>
        <div className="d-flex flex-column">
          <div className="h-100">
          <div className="heading-border"><h3>{vessel.Navn}</h3></div>
            {vessel.Rederi && <div className="row"><div className="col-3">Rederi: </div><div className="col-9">{vessel.Rederi}</div></div>}
            {vessel.Byggeaar && <div className="row"><div className="col-3">Byggeår: </div><div className="col-9">{vessel.Byggeaar}</div></div>}
            <div className=""></div>
            {vessel.Kallesignal && <div className="row"><div className="col-3">Kallesignal: </div><div className="col-9">{vessel.Kallesignal}</div></div>}
            {vessel.Nettside && <div className="row"><div className="col-3">Nettside: </div><div className="col-9">{vessel.Nettside}</div></div>}
            {vessel.Epost && <div className="row"><div className="col-3">E-post: </div><div className="col-9"><a href={`mailto:${vessel.Epost}`}>{vessel.Epost}</a></div></div>}
            {vessel.Telefon && <div className="row"><div className="col-3">Telefon: </div><div className="col-9"><a href={`tel:0047${vessel.Telefon}`}>{vessel.Telefon}</a></div></div>}
          </div>
        </div>
        </div>
        <div className="bottomtype h-100">
          
            {vessel.Type &&
              <div className="row d-flex flex-row justify-content-end align-items-end h-100">
                <div className="col-12 bottomtype-line">
                  <div className="row">
                  <div className="heading-border"></div>
                    <div className="col-12 text-center">{vessel.Type}</div>
                  </div>
                  
                </div>
              </div>
            }
        </div>
      </div>
    </motion.div>
  ));
  // .slice(0,5);

  return (
    <div className="container App">
      <div className="">
      <div>

        <div className="filter-container mb30 d-flex justify-content-between">
            <div>
            <div className="">Sorter etter type:</div>
                <select
                  name="category-list"
                  id="category-list"
                  onChange={handleCategoryChange}
                >
                  <option value="">Alle</option>
                  {vesselCategoryOptions}
                  
                </select>
            </div>
            <div>
              <div className="">&nbsp;</div>
              <input type="text" placeholder="Søk..." onChange={(e) => searchVessels(e.target.value)}></input>
            </div>
          </div>
        </div>
      </div>
      <div className="row d-flex flex-wrap">
        
        {vessels}
      </div>
    </div>
  );
}

export default Vessels